




























































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  getdatalist,
  getresultData,
  getstudentData,
  getrasheettype,
  getrasheetdetail,
} from "@/api/resultsAnalyse";
import moment, { isMoment } from "moment";
import { drawEchart } from "./../../publicjs/echarts";
import { drawelineEcharts } from "./../../publicjs/echartsline";
import { drawBarLinechart } from "./../../publicjs/drawBarLinechart";
@Component({
  name: "equipManage",
})
export default class extends Vue {
  [x: string]: any;

  mounted() {
    this.$nextTick(() => {
      this.listQuery.orginizeid = this.getsession().orgnizeid;
      this.getlist(this.listQuery);
    });
  }
  updated() {}
  private listQuery: any = {
    name: "",
    page: 1,
    limit: 10,
    begintime: null,
    endtime: null,
    timetype: "",
    orginizeid: "",
  };
  private diaQuery = {
    id: "",
    page: 1,
    limit: 10,
    begintime: null,
    endtime: null,
    timetype: "",
  };
  private studentquery = {
    id: "",
    page: 1,
    limit: 10,
  };
  private content = {
    name: "",
    injuryname: "",
  };
  private rasheetquery = {
    id: "",
    rasheetid: "",
  };
  private isloading = true;
  private tableData: any = [];
  private studentData: any = [];
  private rasheetcontent: any = {};
  private diatableData: any = []; //模态框列表
  private multiarry: any = []; //表格复选框id
  private total: number = 0;
  private diatotal: number = 0;
  private studenttotal: number = 0;
  private echartsFirstUpdate: any = []; //更新后的echats图
  private echartsFirstUpdateDia: any = []; //更新后的echats图
  private echartsXdata: any = []; //考核次数echarts横轴数据
  private echartsYdata: any = []; //考核次数echarts横轴数据echarts纵轴数据
  private echartpersonXdata: any = []; //考核人次echarts横轴数据
  private echartpersonYdata: any = []; //考核人次echarts纵轴数据
  private dialogXbardata: any = []; //对话框x轴柱状图数据
  private dialoghelpdata: any = []; //对话框x轴辅助数据
  private dialogXlinedata: any = []; //对话框x轴折线图数据
  private dialogBzdata: any = []; //对话框标准差数据
  private dialogYmaxdata: any = []; //对话框y轴数据
  private dialogYmindata: any = []; //对话框y轴数据
  private studentArr: any = []; //复选的考生数据
  private button = [{ name: "周" }, { name: "月" }, { name: "年" }];
  private isactive = 4;
  private type = "primary";
  private dialoading = true;
  private selectValue = "";
  // private dialoading: any = this.$loading({
  //   lock: false,
  //   text: "Loading",
  //   spinner: "el-icon-loading",
  //   background: "rgba(0, 0, 0, 0.7)",
  //   target: this.$refs.diamain as any,
  // });
  private allParams = {
    listLoading: false,
    dataValue: "",
    title: "",
    dataType: "week",
    beginType: "开始周",
    endType: "结束周",
    dateText: "yyyy 第 WW 周",
    dialogVisible: false,
    studentvisible: false,
    rasheetvisible: false,
    studenttitle: "",
    rasheettitle: "",
  };
  private rasheetoptions: any = [];
  private starttime = {
    disabledDate: (time: any) => {
      if (this.listQuery.endtime) {
        return time.getTime() > new Date(this.listQuery.endtime).getTime();
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private endtime = {
    disabledDate: (time: any) => {
      if (this.listQuery.begintime) {
        return (
          time.getTime() > Date.now() ||
          time.getTime() < new Date(this.listQuery.begintime).getTime()
        );
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
  private async searchData() {
    (this.$refs.tableref as any).clearSelection();
    if (this.listQuery.timetype != "") {
      if (this.listQuery.begintime == null && this.listQuery.endtime == null) {
        this.$message({
          message: "请选择起始和结束时间",
          type: "warning",
        });
      } else {
        await getdatalist(this.listQuery).then((res) => {
          if (res.code === 200) {
            this.loading = false;
            this.tableData = res.data.items;
            this.total = res.data.total;
          }
        });
      }
    } else {
      this.listQuery.begintime = null;
      this.listQuery.endtime = null;
      await getdatalist(this.listQuery).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          this.tableData = res.data.items;
          this.total = res.data.total;
        }
      });
    }
  }
  private async clearSearch() {
    (this.$refs.tableref as any).clearSelection();
    this.isactive = 4;
    this.listQuery = {
      name: "",
      page: 1,
      limit: 10,
      begintime: null,
      endtime: null,
      timetype: "",
    };
    this.getlist(this.listQuery);
  }
  // 时间控件改变事件

  private changeFocus() {
    if (this.listQuery.timetype == "") {
      this.$message({
        message: "请先选择时间粒度",
        type: "warning",
      });
    }
  }
  // 获取列表
  private async getlist(parm: any) {
    this.allParams.listLoading = true;
    await getdatalist(parm).then((res) => {
      if (res.code === 200) {
        this.tableData = res.data.items;
        this.total = res.data.total;
        this.isloading = false;
        if (this.listQuery.page == 1) {
          this.$nextTick(() => {
            this.toogleTbale(this.tableData, "table");
          });
        }
        this.tableData.forEach((item: any) => {
          this.echartsXdata.push(item.organizename);
          this.echartsYdata.push(item.assessnumber);
          this.echartpersonYdata.push(item.assesspersonnum);
        });
        drawEchart(
          this.$refs.echartsTopDiv,
          this.echartsXdata,
          this.echartsYdata,
          "考核次数分布图",
          "考核次数",
          "组织名称"
        );
        drawelineEcharts(
          this.$refs.echartsBotDiv,
          this.echartsXdata,
          this.echartpersonYdata,
          "考核人数分布图"
        );
      }
    });
  }
  // 默认全部加载选中
  private toogleTbale(rows: any, type: any) {
    if (rows) {
      if (type == "table") {
        rows.forEach((row: any) => {
          (this.$refs.tableref as any).toggleRowSelection(row);
        });
      } else {
        rows.forEach((row: any) => {
          (this.$refs.diatableref as any).toggleRowSelection(row);
        });
      }
    }
  }
  private async watchDetail(row) {
    this.allParams.studenttitle = row.testname;
    this.allParams.studentvisible = true;
    this.studentquery.id = row.id;
    this.rasheetquery.id = row.id;
    await getstudentData(this.studentquery).then((res) => {
      if (res.code === 200) {
        this.studentData = res.data.items;
        this.studenttotal = res.data.total;
      }
    });
  }
  // 获取sessionstorage
  private getsession() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    return parma;
  }
  private async watchrasheet(row) {
    this.allParams.rasheettitle = row.name;
    let paramid = {
      id: row.id,
    };
    await getrasheettype(paramid).then((res) => {
      if (res.code === 200) {
        const options = res.data;
        options.forEach((item: any) => {
          this.rasheetoptions.push({
            value: item.id,
            label: item.label,
          });
        });
        this.selectValue = this.rasheetoptions[0].label;
        this.rasheetquery.rasheetid = this.selectValue;

        getrasheetdetail(this.rasheetquery).then((res) => {
          if (res.code === 200) {
            this.rasheetcontent = res.data;
          }
        });
        this.allParams.rasheetvisible = true;
      }
    });
  }
  private changerasheet(val) {
    this.rasheetquery.rasheetid = val;
    getrasheetdetail(this.rasheetquery).then((res) => {
      if (res.code === 200) {
        this.rasheetcontent = res.data;
      }
    });
  }
  private handleSelectionChangedia(val: any) {
    this.echartsFirstUpdateDia = val;
    this.dialogYmindata = [];
    this.dialogXlinedata = [];
    this.dialogYmaxdata = [];
    this.dialoghelpdata = [];
    this.dialogBzdata = [];
    this.dialogXbardata = [];
    this.echartsFirstUpdateDia.forEach((val: any) => {
      this.dialogXbardata.push(val.testname);
      this.dialogYmindata.push(val.testmin),
        this.dialogXlinedata.push(val.testtandard),
        this.dialogYmaxdata.push(val.testmax),
        this.dialoghelpdata.push(val.testmax + val.testmin),
        this.dialogBzdata.push(val.testaverage);
    });

    drawelineEcharts(
      this.$refs.diaBotEchart,
      this.dialogXbardata,
      this.dialogBzdata,
      "标准差分布图"
    );
    drawBarLinechart(
      this.$refs.diaTopEchart,
      this.dialogXbardata,
      this.dialoghelpdata,
      this.dialogXlinedata,
      this.dialogYmaxdata,
      this.dialogYmindata,
      "分数分布图",
      "考试名称"
    );
    // this.drawDiawechart(this.$refs.diaTopEchart, optionnum)
  }
  private selectStudent(val: any) {
    this.studentArr = val;
  }
  // 表格数据多选事件
  private async handleSelectionChange(val: any) {
    this.echartsXdata = [];
    this.echartsYdata = [];
    this.echartpersonYdata = [];
    // this.multiarry.push(val.id);
    this.echartsFirstUpdate = val;
    this.echartsFirstUpdate.forEach((item: any) => {
      this.echartsXdata.push(item.organizename);
      this.echartsYdata.push(item.assessnumber);
      this.echartpersonYdata.push(item.assesspersonnum);
    });
    drawEchart(
      this.$refs.echartsTopDiv,
      this.echartsXdata,
      this.echartsYdata,
      "考核次数分布图",
      "考核次数",
      "组织名称"
    );
    drawelineEcharts(
      this.$refs.echartsBotDiv,
      this.echartsXdata,
      this.echartpersonYdata,
      "考核人数分布图"
    );
  }
  // 更改按钮状态
  private changetage(parm: any) {
    //将点击的元素的索引赋值给bian变量
    this.listQuery.begintime = null;
    this.listQuery.endtime = null;
    if (parm == 0) {
      this.listQuery.timetype = "week";
      this.allParams.beginType = "开始周";
      this.allParams.endType = "结束周";
      this.allParams.dateText = "yyyy 第 WW 周";
    } else if (parm == 1) {
      this.listQuery.timetype = "month";
      this.allParams.beginType = "开始月";
      this.allParams.endType = "结束月";
      this.allParams.dateText = "";
    } else if (parm == 2) {
      this.listQuery.timetype = "year";
      this.allParams.beginType = "开始年";
      this.allParams.dateText = "";
      this.allParams.endType = "结束年";
    }
    this.isactive = parm;
  }

  // 查看成绩
  private async watchResult(parm: any) {
    this.dialoading = true;
    this.allParams.dialogVisible = true;
    this.dialogXlinedata = [];
    this.dialogYmaxdata = [];
    this.dialoghelpdata = [];
    this.dialogBzdata = [];
    this.dialogXbardata = [];
    this.dialogYmindata = [];
    // 查看成绩请求参数 this.diaQuery
    this.diaQuery.page = 1;
    this.diaQuery.id = parm.id;
    this.diaQuery.begintime = this.listQuery.begintime;
    this.diaQuery.endtime = this.listQuery.endtime;
    this.diaQuery.timetype = this.listQuery.timetype;
    await getresultData(this.diaQuery).then((res) => {
      if (res.code == 200) {
        this.diatableData = res.data.items;
        this.diatotal = res.data.total;
        this.dialoading = false;
        if (this.diaQuery.page === 1) {
          this.$nextTick(() => {
            this.toogleTbale(this.diatableData, "dialog");
          });
        }
      }
    });
  }
  private handleClose(done: any) {
    this.allParams.dialogVisible = false;
  }
  private handleClosestudent() {
    this.allParams.studentvisible = false;
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }

  // 绑定表格初次加载默认显示加载数据方法
  private toogleData(arr: any) {
    if (arr) {
      const result = this.tableData.find();
    }
  }

  //绑定echarts;
  // private drawEcharts(
  //   ref: any,
  //   xdata: any,
  //   ydata: any,
  //   title: string,
  //   yname: string
  // ) {
  //   let mychart = this.$echarts.init(ref);
  //   // 绘制图表
  //   mychart.setOption({
  //     title: { text: title },
  //     tooltip: {},
  //     color: ["#3398DB"],
  //     legend: {},

  //     xAxis: {
  //       data: xdata,
  //       name: "组织名称",
  //     },
  //     yAxis: {
  //       name: yname,
  //     },
  //     series: [
  //       {
  //         type: "bar",
  //         data: ydata,
  //       },
  //     ],
  //   });
  // }

  private drawDiawechart(ref: any, seriers: any) {
    let mychart = this.$echarts.init(ref);
    let seriesParm: any[] = [];
    if (seriers.ymaxdata) {
      seriesParm = [
        {
          // name: "辅助",
          type: "bar",
          stack: "总量",
          itemStyle: {
            barBorderColor: "rgba(0,0,0,0)",
            color: "rgba(0,0,0,0)",
          },
          emphasis: {
            itemStyle: {
              barBorderColor: "rgba(0,0,0,0)",
              color: "rgba(0,0,0,0)",
            },
          },
          data: seriers.yhelpdata,
        },
        {
          name: "平均分",
          type: "line",
          stack: "总量",
          data: seriers.linedata,
        },
        {
          name: "最低分",
          type: "bar",
          stack: "总量",
          color: "rgb(249,205,176)",
          label: {
            show: true,
            position: "top",
          },
          data: seriers.ymindata,
        },
        {
          name: "最高分",
          type: "bar",
          stack: "总量",
          color: "rgb(131,175,155)",
          label: {
            show: true,
            position: "bottom",
          },
          data: seriers.ymaxdata,
        },
      ];
    } else {
      seriesParm = [
        {
          name: "标准差",
          type: "line",
          data: seriers.linedata,
          color: "rgb(20,68,106)",
        },
      ];
    }
    // 绘制图表
    mychart.setOption({
      title: { text: seriers.title },
      tooltip: {},
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        splitLine: { show: false },
        data: seriers.namedata,
      },
      yAxis: {
        type: "value",
      },
      series: seriesParm,
    });
  }
  // 成绩列表分页方法
  private async handleSizeChange(val: number) {
    this.listQuery.limit = val;
    (this.$refs.tableref as any).clearSelection();
    this.getlist(this.listQuery);
  }
  private async handleCurrentChange(val: number) {
    this.listQuery.page = val;
    await getdatalist(this.listQuery).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        this.tableData = res.data.items;
        this.total = res.data.total;
      }
    });
  }
  // private open() {
  //   this.$nextTick(() => {
  //     //  执行echarts方法
  //     // drawelineEcharts();
  //     drawEchart("", this.dialogXdata, this.dialogYdata, "1");
  //   });
  // }
  // 对话框列表分页方法
  private async handleSizeChangedia(val: number) {
    this.diaQuery.limit = val;
    (this.$refs.diatableref as any).clearSelection();
    await getresultData(this.diaQuery).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        this.tableData = res.data.items;
        this.diatotal = res.data.total;
      }
    });
  }
  private async handleCurrentChangedia(val: number) {
    this.diaQuery.page = val;
    await getresultData(this.diaQuery).then((res) => {
      if (res.code === 200) {
        this.loading = false;
        this.diatableData = res.data.items;
        this.diatotal = res.data.total;
      }
    });
  }
  // 导出成绩表
  exportResult() {
    if (this.studentArr.length == 0) {
      this.$message.warning("请选择要导出的成绩");
    } else {
      const idlist: any = [];
      this.studentArr.forEach((item: any) => {
        idlist.push(item.id);
      });
      // 调取导出成绩的接口
    }
  }
}
